import { render, staticRenderFns } from "./side-tree.vue?vue&type=template&id=224474ec&scoped=true&"
import script from "./side-tree.vue?vue&type=script&lang=js&"
export * from "./side-tree.vue?vue&type=script&lang=js&"
import style0 from "./side-tree.vue?vue&type=style&index=0&id=224474ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224474ec",
  null
  
)

export default component.exports